<template>
  <!-- 调拨出库详情 -->
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="adjustProduct" v-show="documentStatus === 1">调拨产品</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col>
        <el-table :data="tableData" stripe border>
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column label="品名" prop="NAME"></el-table-column>
          <el-table-column label="编号" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
          <el-table-column label="单价" prop="PRODUCT_PRICE"></el-table-column>
          <el-table-column label="批次" prop="BATCH"></el-table-column>
          <el-table-column label="调拨数量" prop="PRODUCT_COUNT"></el-table-column>
          <el-table-column label="价值" prop="PRODUCT_WORTH"></el-table-column>
          <el-table-column label="价值（不含税）" prop="PRODUCT_WORTH_BEFORE_TAX"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      documentStatus: Number(sessionStorage.getItem('status')),
    };
  },
  methods: {
    adjustProduct() {
      this.$router.push({
        path: `/adjust_product/${this.$route.params.id}`,
        params: { id: this.$route.params.id },
      });
    },
    queryDetail() {
      const params = {
        SERVICE_ID: '10061',
        OTYPE: 3,
        TRANSFER_ID: Number(this.$route.params.id),
      };
      http
        .post(params)
        .then((result) => {
          // 去除数量.00操作
          for (let i = 0; i < result.length; i++) {
            result[i].PRODUCT_COUNT = parseFloat(result[i].PRODUCT_COUNT);
          }
          if (result[0]) {
            this.tableData = result;
          } else {
            this.tableData = [];
          }
        })
        .catch((err) => {
          this.$message.show({
            text: err,
            type: 'error',
          });
        });
    },
  },
  created() {
    this.queryDetail();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/warehouseManage/adjust_out_detail.vue